var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_187_3051",
    transform: "scale(0.0227273)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_187_3051",
    width: 44,
    height: 44,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG3SURBVHgB7ZmBbYMwEACfqgNkBEZIN6CTQCdoNyAZoRtkA7oB3SDdIGxANvg+wqleKX6/qbHTiJNeIPuNL44xwQFYWblTELGgaCl6jEdv+tz6ytaYnnrKLZuQHT7dEW6D5yzLPsUMHL+SC0eKDUSC+spNnxdaTSM+Z3OIzDBArP/+un5qSuBPJQEJkBwe4J/xCDMwU6WkGI5nincaiA5SwNcVS32J02tzDYFwOaiTzV0sUUAAJAffOfzGzjuKF4oPS30cHCN8YNWVKduyshMEIOQIn9n5K45PxZKVda4L4LjO5hAKxwgXKFM5rj3cAyeTW89x8E6m4p1F9gB6WZSkgwqbnIqiwfG533iOLLqkgwv7YJFtJOlkwhbZytTtbNJJhCVZljMpHV1YIytJRxX2kRWk4wjPkXVJaxrOEv6LrCStaeQtHELWJq1p4CUcUnaWg0/yErK+DurkpWR9HNTJS8pqHdTJS8tqHNTJMWRdDurkWLKSgy2Zv8JvEsjmrI9e06BlDYYf6EVE2Q06NgOn9tYKOrRwGzzRjtIXL/j11mz2Y/eQnv21rAiO+w0tpvnLoICVlTvlG9KB+vVxFWQ+AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.670d17ba1457b6b3ca2d4b728a74f240.svg";
export { ForwardRef as ReactComponent };